<template>

  <el-form ref='licenseeForm' v-model="telco" label-position="top">
    <el-row :gutter="24">

      <el-col :span="12">
        <el-form-item label="Sharer">
          <strong>{{sharerName}}</strong>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="Telco Site ID" required>
          <el-input placeholder="Site ID" v-model="telco.telcoSiteId" :disabled="stepSaved || canEdit" />
        </el-form-item>
      </el-col>
    </el-row>

    <section  v-if="!canEdit">
      <el-row :gutter="12">
        <el-col :md="24" :lg="12">
          <el-form-item label="Sharer No.">
            <el-input-number v-model="telco.sharerNo" :min="1" :max="99" :step="1"
            controls-position="right" size="small" placeholder="Auto" :disabled="stepSaved || canEdit" />
            <div>Leave blank to auto-assign the next free number.</div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :md="24" :lg="12">
          <select-service-type v-model="telco.serviceType"  :disabled="stepSaved || canEdit" />
        </el-col>

        <el-col  :md="24" :lg="12">
          <select-spectrum v-model="telco.spectrumBand"  :disabled="stepSaved || canEdit" />
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :md="24">
          <sharer-rate-override
            v-model="telco.rate_id"
            :sharer-id="sharerId"
            :disabled="stepSaved || canEdit" />
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :md="24" :lg="12">
          <el-form-item label='Handover Date' required>
            <el-date-picker value-format="yyyy-MM-dd" :format="format"
            v-model="telco.handover"  :disabled="stepSaved || canEdit" />
          </el-form-item>
        </el-col>

        <el-col :md="24" :lg="12">
          <el-form-item label='Commencement Date' required>
            <el-date-picker value-format="yyyy-MM-dd" :format="format"
            v-model="telco.started"  :disabled="stepSaved || canEdit" />
          </el-form-item>
        </el-col>

        <el-col :md="24" :lg="12">
          <el-form-item label='On Air Date'>
            <el-date-picker value-format="yyyy-MM-dd" :format="format"
            v-model="telco.onAir"  :disabled="stepSaved || canEdit" />
          </el-form-item>
        </el-col>

        <el-col :md="24" :lg="12">
          <el-form-item label='Expiry Date'>
            <el-date-picker value-format="yyyy-MM-dd" :format="format"
            label='Contract End' v-model='expiryDate' disabled />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="8">
        <el-col :span="12">
          <el-form-item prop="capex" label="CAPEX">
            <el-input type="number" placeholder="CAPEX"
            v-model="telco.capex"  :disabled="stepSaved || canEdit"/>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="OPEX">
            <el-input type="number" placeholder="OPEX" v-model="telco.opex"
            :disabled="stepSaved || canEdit" />
          </el-form-item>
        </el-col>
      </el-row>


      <el-row :gutter="8">
        <el-col :span="12">
          <el-form-item>
            Cabins &nbsp;<el-input-number v-model="telco.cabin" :min="0" :max="5" size="mini" :disabled="stepSaved || canEdit" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <check-box v-model="telco.ownMeter"  :disabled="stepSaved || canEdit">{{'Own  ' + utilLabel + ' Meter'}}</check-box>
        </el-col>
      </el-row>

      <el-form-item label='Tenor (years)'>
        <el-slider
        v-model="tenor" :min="1" :max="20" show-stops show-input  :disabled="stepSaved || canEdit">
      </el-slider>
    </el-form-item>

    <el-row>
      <el-col align="middle">
        <el-button :plain="true" type="success" icon="fa fa-check" @click="onSave" :disabled="stepSaved || canEdit">Save</el-button>
        <el-button v-if="isSuper()" :plain="true" type="error" icon="fa fa-edit" @click="stepSaved=false"></el-button>
      </el-col>
    </el-row>
</section>
</el-form>

</template>


<script>

import {settings} from '@/components/Data'

import PostMixins from '@/mixins/PostMixins'
import DateMixins from '@/mixins/DateMixins'

import SelectServiceType from '@/components/atoms/selects/SelectServiceType'
import SelectSpectrum from '@/components/atoms/selects/SelectSpectrum'
import SharerRateOverride from '@/components/finance/rates/SharerRateOverride'

export default {
  mixins: [DateMixins, PostMixins],

  components: {
    SelectServiceType,
    SelectSpectrum,
    SharerRateOverride
  },

  props: {
    siteId: {
      type: [String, Number],
      required: true
    },

    sharerName: {
      type: String,
      required: true
    },

    sharerId: {
      type: Number,
      required: true
    },

    editable: {
      type: Boolean,
      default: false
    },

    saved: {
      type: Boolean,
      default: false
    },

    sharerSiteId: {
      type: String,
      default: null
    },

    serviceType: {
      type: String,
      default: null
    },

    spectrumBand: {
      type: String,
      default: null
    },

    equipment: {
      type: Array,
      default: []
    }
  },

  methods: {
    // Pushes posts to the server when called.
    resetData () {
      this.telco = this.getTableStruct('licensee')
      this.telco.site_id = this.siteId
    },

    // XOL-416 (was XOL-376 Inc 4): prefill the Sharer No. from the server-suggested
    // next free slot. {suggested:N} comes back as raw JSON, no data wrapper.
    applyBillingSuggestion (data) {
      this.telco.sharerNo = (data && data.suggested) ? data.suggested : null
    },

    // fetchData already toasts on failure — no extra message here. Leaving it
    // blank is safe: the server assigns MAX(Active)+1 when the key is omitted,
    // which is the same number the suggestion endpoint would have returned.
    onSuggestionFail () {
      this.telco.sharerNo = null
    },

    onSave () {
      this.telco.site_id = this.siteId
      this.telco.organisation_id = this.sharerId

      // XOL-416: omit `sharerNo` unless it is a valid 1-99 int, so the server
      // assigns MAX(Active)+1 itself. The meta struct seeds numeric fields to 0
      // and a failed/skipped prefill leaves null — sending either would be wrong
      // here: 0 is the deliberate UNASSIGNED sentinel and must never be set by
      // accident at create time, and null is a no-op the server would ignore.
      var n = parseInt(this.telco.sharerNo, 10)
      if (!(n >= 1 && n <= 99)) {
        delete this.telco.sharerNo
      } else {
        this.telco.sharerNo = n
      }

      if (this.telco.started === 'invalid date') {
        this.telco.started = null
      }

      if (this.telco.expiry === 'invalid date') {
        this.telco.expiry = null
      }

      this.telco.outdoor = !this.telco.cabin

      this.telco.started = this.formatDateSql(this.telco.started)
      this.telco.expiry = this.formatDateSql(this.telco.expiry)

      this.telco.handover = this.formatDateSql(this.telco.handover)
      this.telco.onAir = this.formatDateSql(this.telco.onAir)

      if (this.telco && this.equipment && this.equipment.length > 0) {
        this.telco.equipment = this.equipment
      }

      this.saveForm(this, '/licensees', this.telco.id, this.telco, 'Sharer', this.success, this.failed)
    },

    success (response) {
      if (this.telco.cabin > 0) {
        let cabinAsset = {}
        cabinAsset.owner_id = this.telco.organisation_id
        cabinAsset.site_id = this.telco.site_id
        cabinAsset.category = 'Buildings'
        cabinAsset.type = 'Cabin'
        cabinAsset.qty = this.telco.cabin
        cabinAsset.isAuditable = true
        cabinAsset.usesPower = true
        cabinAsset.isExternal = true
        this.saveForm(this, '/assets', null, cabinAsset,  'Cabins', null, null, false)
      }


      if (this.telco.ownMeter) {
        let meterAsset = {}
        meterAsset.owner_id = this.telco.organisation_id
        meterAsset.site_id = this.telco.site_id
        meterAsset.category = 'Power'
        meterAsset.type = 'Own Meter'
        meterAsset.qty = 1
        meterAsset.isAuditable = false
        meterAsset.providesPower = true
        meterAsset.usesPower = false
        meterAsset.isExternal = true
        this.saveForm(this, '/assets', null, meterAsset, 'Own Meter', null, null, false)
      }

      this.stepSaved = true
    },

    failed (response) {
      console.error('Sharer Form save failed:', response)
      this.stepSaved = false
    }
  },

  computed: {
    expiryDate: function () {
      this.telco.expiry = this.contractExpiryDate(this.telco.started, this.tenor, 'years', 'YYYY-MM-DD')
      return this.telco.expiry
    }
  },

  data () {
    return {
      format: settings.selectDateFormat,
      tenor: 10,
      canEdit: this.editable,
      stepSaved: this.saved,
      utilLabel: this.getUtilLabel(),
      telco: this.getTableStruct('licensees')
    }

  }, // data


  created () {
    this.telco.telcoSiteId = this.sharerSiteId
    this.telco.spectrumBand = this.spectrumBand
    this.telco.serviceType = this.serviceType

    // XOL-416: only prefill the Sharer No. suggestion in create mode — an
    // already-saved/editable step already has its number. Clear the meta-seeded 0
    // first so the field shows the "Auto" placeholder while the suggestion is in
    // flight, instead of a flash of "0" (which now reads as "unassigned").
    if (!this.saved && !this.editable && this.siteId) {
      this.telco.sharerNo = null
      this.fetchData('licensees/next-sharer-no?site_id=' + this.siteId, this.applyBillingSuggestion, 'next sharer number', this.onSuggestionFail)
    }
  }
}

</script>
